import React, { useEffect, useRef, useState } from "react";
import doxzonLogo from "../assets/doxzon-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaShoppingCart, FaTimes } from "react-icons/fa";
import { Avatar, Badge, Drawer, Dropdown, Menu, Modal, Tooltip } from "antd";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Login from "../Authentication/Login";
import { GiHealing } from "react-icons/gi"; 
import { MdContactEmergency } from "react-icons/md";
import EmergencyDataView from "./EmergencyDataView";
import { IoIosChatboxes, IoIosNotifications } from "react-icons/io";
import LiveChat from "../Pages/LiveChat/chat";
import { countUnreadMessages } from "../Services/chatService";
import { useDispatch, useSelector } from "react-redux";
import { GETCOUNT } from "../Redux/actions/ChatActions";
import SignUp from "../Authentication/SignUp";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
  SIGNUPMODAL,
} from "../Redux/actions/commonActions";
import { getNotificationCount } from "../Redux/actions/NotificationActions";
import {
  clearLoggedUser,
  deleteDataFromLocal,
} from "../Redux/actions/AuthActions";
import MembershipSlider from "./MembershipSlider";
import { clearSelectedAppt } from "../Redux/actions/appointmentActions";
import ConsentPopup from "../Pages/Consent/ConsentPopup";
import ConsentServices from "../Services/ConsentServices";
import CallDoctorModal from "./CallDoctorModal";
import {
  Stethoscope,
  Building2,
  UserCog,
  Users,
  Pill,
  TestTube,
  FileText,
  ChevronRight,
  ShieldCheck,
  X,
  Home,
  Calendar,
  Salad,
  Star,
  ClipboardList,
  CreditCard,
  Box,
  LayoutGrid,
  Settings,
  LogOut,
  Radio,
  User,
  PhoneCall,
  Activity,
  ShieldAlert,
  LayoutDashboard,
} from "lucide-react";

const PREMIUM_THEME_STYLE = `
  :root[data-theme="dark"] {
    --dox-bg-primary: #0a0800;
    --dox-text-primary: #f5e6b0;
  }
  [data-theme="dark"] body { background: #0a0800 !important; color: #f5e6b0 !important; }
  
  .dox-logo { transition: filter 0.3s ease; }
  [data-theme="dark"] .dox-logo {
    filter: brightness(0) invert(1) sepia(1) saturate(4) hue-rotate(5deg) brightness(1.05);
  }

  .premium-mobile-drawer .ant-drawer-content {
    background: rgba(255, 255, 255, 0.85) !important;
    backdrop-filter: blur(20px) !important;
    -webkit-backdrop-filter: blur(20px) !important;
  }
  [data-theme="dark"] .premium-mobile-drawer .ant-drawer-content {
    background: rgba(15, 11, 2, 0.90) !important;
    border-right: 1px solid rgba(200, 150, 30, 0.2) !important;
  }
  .premium-mobile-drawer .ant-drawer-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
    background: transparent !important;
  }
  [data-theme="dark"] .premium-mobile-drawer .ant-drawer-header {
    border-bottom: 1px solid rgba(200, 150, 30, 0.15) !important;
    background: transparent !important;
  }
  .premium-mobile-drawer .ant-drawer-title {
    font-weight: 700 !important;
    letter-spacing: 0.5px;
    font-size: 16px !important;
  }
  [data-theme="dark"] .premium-mobile-drawer .ant-drawer-title {
    color: #f0c040 !important;
  }
`;
const NAV_ITEMS = [
  { label: "Consultation", route: APP_ROUTES.CONSULTDOCTOR },
  { label: "Clinics", scrollTo: "clinic-section" },
  { label: "Providers", scrollTo: "providers-section" },
  { label: "Patients", scrollTo: "patients-section" },
  { label: "Medicine", route: APP_ROUTES.MEDICINES },
  { label: "Lab Tests", route: APP_ROUTES.LABTESTS },
  { label: "Referral", route: APP_ROUTES.HOSPITALSERVICE },
];

const DRAWER_ICONS = {
  Consultation: <Stethoscope size={22} />,
  Clinics: <Building2 size={22} />,
  Providers: <UserCog size={22} />,
  Patients: <Users size={22} />,
  Medicine: <Pill size={22} />,
  "Lab Tests": <TestTube size={22} />,
  Referral: <FileText size={22} />,
  Home: <Home size={22} />,
  "Call Doctor": (
    <span className="call-doctor-btn" title="Call Doctor">
      <span className="call-doctor-icon">
        <PhoneCall size={18} color="#1D9E75" />
      </span>
    </span>
  ),
  "My Profile": <User size={22} />,
  Appointments: <Calendar size={22} />,
  "Family Members": <Users size={22} />,
  "Diet Plan": <Salad size={22} />,
  Membership: <Star size={22} />,
  "Medical Records": <ClipboardList size={22} />,
  Payments: <CreditCard size={22} />,
  "Order History": <Box size={22} />,
  Consent: <ShieldCheck size={22} />,
  "Emergency Data": <ShieldAlert size={22} />,
  "Health Summary": <Activity size={22} />,
  Devices: <Radio size={22} />,
  "Procedure List": <LayoutGrid size={22} />,
  Settings: <Settings size={22} />,
  Logout: <LogOut size={22} />,
  Dashboard: <LayoutDashboard size={22} />,
};


const sideMenuStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap');

  .dox-nav-link {
    position: relative;
    font-family: 'Outfit', sans-serif;
  }
  .dox-logo {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .dox-logo:hover {
    transform: scale(1.05);
  }
`;

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showsideMenuDropdown, setShowsideMenuDropdown] = useState(false);
  const [emgDataModal, setEmgDataModal] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [medRecordsOpen, setMedRecordsOpen] = useState(false);
  const [consentModalVisible, setConsentModalVisible] = useState(false);
  const [fetchedConsentData, setFetchedConsentData] = useState(null);
  const [callDoctorModalVisible, setCallDoctorModalVisible] = useState(false);
  const sideMenudropdownRef = useRef(null);
  const headerdropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { selectedType, regModal, loginModal } = useSelector(
    (state) => state.common,
  );
  const { loggedUser: reduxLoggedUser } = useSelector((state) => state.auth);

  // Use redux user if available, otherwise fallback to localStorage for persistence
  const loggedUserJson = localStorage.getItem("patientData");
  const localLoggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const loggedUser = reduxLoggedUser || localLoggedUser;

  const totalnotifyCount = useSelector((state) => state.chatCount.count);
  const notificationCount = useSelector(
    (state) => state.notificationCount.count,
  );
  const { cartData } = useSelector((state) => state.cart);
  const [isMobile, setIsMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const darkMode = localStorage.getItem("dox-theme") === "dark";

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const id = "dox-premium-theme-style";
    if (!document.getElementById(id)) {
      const tag = document.createElement("style");
      tag.id = id;
      tag.textContent = PREMIUM_THEME_STYLE;
      document.head.appendChild(tag);
    }
  }, []);

  useEffect(() => {
    if (!loggedUser) return;
    const onCountChange = (size) => {
      dispatch({ type: GETCOUNT, payload: size });
    };
    const unsubscribe = countUnreadMessages(
      loggedUser.patientId,
      onCountChange,
    );
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [loggedUser, dispatch]);

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    if (location.hash === "#HospitalService") {
      const procedureSection = document.getElementById("HospitalService");
      if (procedureSection)
        procedureSection.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  useEffect(() => {
    if (loggedUser && loggedUser.patientId) {
      const timer = setTimeout(() => {
        checkConsentOnce();
      }, 1000); // Delay by 1 second
      return () => clearTimeout(timer);
    }
  }, [loggedUser?.patientId]);

  const isCheckingConsent = useRef(false);

  const checkConsentOnce = async () => {
    const consentChecked = sessionStorage.getItem("consentChecked");
    if (consentChecked || isCheckingConsent.current) return;

    if (
      location.pathname === APP_ROUTES.LOGCONSENT ||
      location.pathname === APP_ROUTES.CONSENT
    ) {
      return;
    }

    try {
      isCheckingConsent.current = true;
      const consentPayload = {
        patientId: loggedUser.patientId,
      };

      const response = await ConsentServices.getconsentFilter(consentPayload);
      const data = response.data[0];

      const needsConsent =
        !data ||
        data.termsCond === "P" ||
        data.termsCond === "N" ||
        data.privacyPolicy === "P" ||
        data.privacyPolicy === "N" ||
        data.shareMedWithDocs === "P" ||
        data.shareMedWithDocs === "N" ||
        data.shareMedWithHosp === "P" ||
        data.shareMedWithHosp === "N" ||
        data.shareEpresWithPharmacy === "P" ||
        data.shareEpresWithPharmacy === "N" ||
        data.shareEpresWithDiagnostics === "P" ||
        data.shareEpresWithDiagnostics === "N";

      if (needsConsent) {
        setFetchedConsentData(data);
        setConsentModalVisible(true);
      } else {
        sessionStorage.setItem("consentChecked", "true");
      }
    } catch (error) {
      console.error("Error checking consent status:", error);
    } finally {
      isCheckingConsent.current = false;
    }
  };

  const handleClickOutside = (event) => {
    if (
      headerdropdownRef.current &&
      !headerdropdownRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }
  };

  const handleSideMenuSignuUp = () =>
    setShowsideMenuDropdown(!showsideMenuDropdown);
  const handleLoginModal = () =>
    dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
  const handleLoginModalClose = () =>
    dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
  const handleSignUpFromLogin = () => {
    dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
    dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  };
  const handleReg = () =>
    dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  const handleRegClose = () =>
    dispatch(handleLoginSignUpModal({ data: false, actionType: SIGNUPMODAL }));
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const handleNav = (item) => {
    setIsMobileMenuOpen(false);
    if (item.scrollTo) {
      const scrollNow = () => {
        const el = document.getElementById(item.scrollTo);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      // Check if we are already on the landing page (root)
      if (
        window.location.pathname === "/" ||
        window.location.pathname === APP_ROUTES.LOGIN
      ) {
        scrollNow();
      } else {
        // Navigate to the landing page first, then scroll
        navigate(APP_ROUTES.LOGIN);
        setTimeout(scrollNow, 500);
      }
    } else if (item.route) {
      navigate(item.route);
    } else if (item.onClick) {
      item.onClick();
    }
  };
  const handleRoute = (route) => {
    navigate(route);
    setIsMobileMenuOpen(false);
  };
  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(deleteDataFromLocal());
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    handleRoute(APP_ROUTES.LOGIN);
  };
  const handleHSNavigation = () => {
    const currentPath = location.pathname;
    navigate(APP_ROUTES.HEALTHSUMMARY, {
      state: { patientId: loggedUser.patientId, path: currentPath },
    });
  };
  const handleEmgDataView = () => setEmgDataModal(true);
  const handleEmgClose = () => setEmgDataModal(false);
  const handleChatOpen = () => setChatOpen(true);
  const handleChatClose = () => setChatOpen(false);
  const handleCallDoctorOpen = () => {
    setCallDoctorModalVisible(true);
    setIsMobileMenuOpen(false);
  };
  const handleCallDoctorClose = () => setCallDoctorModalVisible(false);

  const menu = (
    <Menu className="w-full">
      <Menu.Item key="1" onClick={() => handleRoute(APP_ROUTES.MYPROFILE)}>
        My Profile
      </Menu.Item>
      {!loggedUser?.parentPatientId && (
        <Menu.Item
          key="2"
          onClick={() => handleRoute(APP_ROUTES.FAMILYMEMBERS)}
        >
          Family Members
        </Menu.Item>
      )}
      <Menu.Item key="3" onClick={() => handleRoute(APP_ROUTES.MYAPPOINMENTS)}>
        Appointments
      </Menu.Item>
      <Menu.SubMenu key="medicalRecords" title="Medical Records">
        <Menu.Item
          key="4-1"
          onClick={() => handleRoute(APP_ROUTES.MEDICALHISTORY)}
        >
          Medical History
        </Menu.Item>
        <Menu.Item
          key="4-2"
          onClick={() => handleRoute(APP_ROUTES.MYPRESCRIPTION)}
        >
          My Prescription
        </Menu.Item>
        <Menu.Item key="4-3" onClick={() => handleRoute(APP_ROUTES.MYREPORTS)}>
          My Reports
        </Menu.Item>
        <Menu.Item
          key="4-4"
          onClick={() => handleRoute(APP_ROUTES.MYLABREPORTS)}
        >
          Lab Reports
        </Menu.Item>
        <Menu.Item key="4-5" onClick={() => handleRoute(APP_ROUTES.MYVITALS)}>
          Vitals
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="5" onClick={() => handleRoute(APP_ROUTES.PAYMENTS)}>
        Payments
      </Menu.Item>
      <Menu.Item key="11" onClick={() => handleRoute(APP_ROUTES.MEMBERSHIP)}>
        Membership
      </Menu.Item>
      <Menu.Item key="9" onClick={() => handleRoute(APP_ROUTES.ORDERHISTORY)}>
        Order History
      </Menu.Item>
      <Menu.Item key="6" onClick={() => handleRoute(APP_ROUTES.CONSENT)}>
        Consent
      </Menu.Item>
      <Menu.Item key="7" onClick={() => handleRoute(APP_ROUTES.SETTINGS)}>
        Settings
      </Menu.Item>
      {loggedUser?.rpmApplicable === "Y" && (
        <Menu.Item key="10" onClick={() => handleRoute(APP_ROUTES.DEVICES)}>
          Devices
        </Menu.Item>
      )}
      <Menu.Item
        key="11b"
        onClick={() => handleRoute(APP_ROUTES.PROCEDURELIST)}
      >
        Procedure List
      </Menu.Item>
      <Menu.Item key="8" onClick={handleLogOut}>
        Logout
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    getNotiCount();
  }, []);
  const getNotiCount = async () => {
    try {
      await dispatch(getNotificationCount());
    } catch (e) {
      console.error(e);
    }
  };

  /* ── helpers for new side menu items ── */
  const isActive = (route) => location.pathname === route;

  const navBg = darkMode
    ? "rgba(15,11,2,0.82)"
    : scrolled
      ? "rgba(255,255,255,0.78)"
      : "rgba(255,255,255,0.55)";
  const navBorder = darkMode
    ? "1px solid rgba(200,150,30,0.25)"
    : "1px solid rgba(18,196,139,0.2)";

  const navLinkStyle = {
    color: darkMode ? "#d4b060" : "#071a3d",
    fontSize: "15px",
    fontWeight: 500,
    textDecoration: "none",
    transition: "all 0.2s ease",
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 h-[70px] flex items-center"
      style={{
        background: navBg,
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        borderBottom: navBorder,
      }}
    >
      {/* Inject side-menu styles */}
      <style>{sideMenuStyles}</style>

      <div className="w-full px-5 h-full flex items-center justify-between">
        {/* ── LEFT: Logo ── */}
        <div className="flex items-center shrink-0">
          {/* Hamburger — mobile only */}
          {isMobile && (
            <button
              onClick={toggleMobileMenu}
              className="bg-transparent border-none p-2 cursor-pointer flex items-center justify-center transition-colors mr-2"
              style={{ color: darkMode ? "#f0c040" : "#071a3d" }}
            >
              <FaBars size={22} />
            </button>
          )}

          <div
            className="cursor-pointer"
            onClick={() =>
              handleRoute(loggedUser ? APP_ROUTES.HOME : APP_ROUTES.LOGIN)
            }
          >
            <img
              className="dox-logo h-8 sm:h-8 w-auto"
              src={doxzonLogo}
              alt="Logo"
              style={{ filter: darkMode ? "none" : "none" }}
            />
          </div>
        </div>

        {/* ── LEFT-CENTER: Plain Nav Links + Phone ── */}
        {!isMobile && (
          <div className="flex-1 flex justify-start items-center gap-8 px-20">
            {NAV_ITEMS.filter(
              (item) =>
                !["Clinics", "Providers", "Patients"].includes(item.label),
            ).map((item) => (
              <button
                key={item.label}
                onClick={() => handleNav(item)}
                className="dox-nav-link bg-transparent border-none cursor-pointer"
                style={{
                  color: darkMode ? "#d4b060" : "#071a3d",
                  fontSize: "14px",
                  fontWeight: 500,
                  padding: "0",
                  letterSpacing: "0.1px",
                }}
              >
                {item.label}
              </button>
            ))}
            {/* Phone Call Doctor — pill icon button */}
            <button
              onClick={handleCallDoctorOpen}
              title="Call Doctor"
              style={{
                width: 38,
                height: 38,
                borderRadius: "10px",
                border: "1.5px solid rgba(24,159,170,0.5)",
                background: "rgba(24,159,170,0.06)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <PhoneCall size={17} color="#1D9E75" />
            </button>
          </div>
        )}

        {/* ── RIGHT: Actions ── */}
        <div className="flex items-center gap-4 shrink-0">
          {!isMobile && (
            <div className="flex items-center gap-3">
              {!loggedUser ? (
                <>
                  {/* Clinics | Providers | Patients pill group */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: darkMode
                        ? "1px solid rgba(200,150,30,0.45)"
                        : "1px solid rgba(24,159,170,0.45)",
                      borderRadius: "999px",
                      overflow: "hidden",
                      background: darkMode
                        ? "rgba(200,150,30,0.04)"
                        : "rgba(24,159,170,0.03)",
                    }}
                  >
                    {["Clinics", "Providers", "Patients"].map((label, idx) => {
                      const item = NAV_ITEMS.find((n) => n.label === label);
                      return (
                        <React.Fragment key={label}>
                          {idx > 0 && (
                            <span
                              style={{
                                width: "1px",
                                height: "16px",
                                background: darkMode
                                  ? "rgba(200,150,30,0.3)"
                                  : "rgba(24,159,170,0.3)",
                                display: "inline-block",
                              }}
                            />
                          )}
                          <button
                            onClick={() => handleNav(item)}
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                              padding: "6px 14px",
                              fontSize: "13px",
                              fontWeight: 500,
                              color: darkMode ? "#d4b060" : "#189FAA",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {label}
                          </button>
                        </React.Fragment>
                      );
                    })}
                  </div>

                  {/* Login Button - smaller */}
                  <button
                    onClick={handleLoginModal}
                    className="dox-login-btn rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
                    style={{
                      border: darkMode
                        ? "1.5px solid rgba(200,150,30,0.50)"
                        : "1.5px solid rgba(24,159,170,0.6)",
                      background: darkMode
                        ? "rgba(200,150,30,0.08)"
                        : "rgba(255,255,255,0.6)",
                      color: darkMode ? "#f0c040" : "#189FAA",
                      fontSize: "12px",
                      fontWeight: 600,
                      padding: "4px 14px",
                    }}
                  >
                    Login
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="text-xs px-3 py-1 rounded font-bold hover:bg-opacity-90 transition-all"
                    style={{
                      background: darkMode ? "#f0c040" : "#189FAA",
                      color: "#fff",
                    }}
                    onClick={() => navigate(APP_ROUTES.DIETPLAN)}
                  >
                    DIET
                  </button>
                  <Tooltip title="Notifications">
                    <Badge count={notificationCount} size="small">
                      <IoIosNotifications
                        className="text-xl cursor-pointer"
                        style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
                        onClick={() => navigate(APP_ROUTES.NOTIFICATION)}
                      />
                    </Badge>
                  </Tooltip>
                  <Tooltip title="Chats">
                    <Badge count={totalnotifyCount} size="small">
                      <IoIosChatboxes
                        className="text-xl cursor-pointer"
                        style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
                        onClick={handleChatOpen}
                      />
                    </Badge>
                  </Tooltip>
                  <Tooltip title="Emergency Info">
                    <MdContactEmergency
                      className="text-xl cursor-pointer"
                      style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
                      onClick={handleEmgDataView}
                    />
                  </Tooltip>
                  <Tooltip title="Health Summary">
                    <GiHealing
                      className="text-xl cursor-pointer"
                      style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
                      onClick={handleHSNavigation}
                    />
                  </Tooltip>
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <Avatar
                      className="cursor-pointer border"
                      style={{
                        backgroundColor: darkMode
                          ? "rgba(200,150,30,0.1)"
                          : "#f1f5f9",
                        color: darkMode ? "#f0c040" : "#189FAA",
                        borderColor: darkMode
                          ? "rgba(200,150,30,0.3)"
                          : "rgba(0,0,0,0.05)",
                      }}
                    >
                      {loggedUser?.firstName?.charAt(0).toUpperCase()}
                    </Avatar>
                  </Dropdown>
                </>
              )}
            </div>
          )}

          {/* Cart Icon */}
          {loggedUser && (
            <div
              className="relative cursor-pointer"
              onClick={() => handleRoute(APP_ROUTES.CART)}
            >
              <FaShoppingCart
                className="text-lg"
                style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
              />
              {cartData?.cartItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                  {cartData.cartItemsCount}
                </span>
              )}
            </div>
          )}

          {/* Mobile Chat Badge */}
          {isMobile && loggedUser && (
            <Badge count={totalnotifyCount} size="small">
              <IoIosChatboxes
                className="text-xl cursor-pointer"
                style={{ color: darkMode ? "#f0c040" : "#189FAA" }}
                onClick={handleChatOpen}
              />
            </Badge>
          )}
        </div>
      </div>

      {/* ── PREMIUM UPGRADED SIDE MENU DRAWER ── */}
      <Drawer
        placement="left"
        open={isMobileMenuOpen}
        closable={false}
        width={300}
        onClose={toggleMobileMenu}
        className="premium-mobile-drawer"
        styles={{
          body: {
            padding: 0,
            overflow: "auto",
            background: darkMode ? "#0a0800" : "#f8fafc",
          },
        }}
      >
        {/* Premium Header */}
        <div
          style={{
            background: darkMode
              ? "linear-gradient(135deg, #0f0b02 0%, #1a1405 100%)"
              : "linear-gradient(135deg, #189FAA 0%, #148a94 45%, #0d7a84 100%)",
            padding: "24px 20px 18px",
            position: "relative",
            minHeight: "140px",
            overflow: "hidden",
            borderBottom: darkMode ? "1px solid rgba(200,150,30,0.2)" : "none",
          }}
        >
          {/* Close Button */}
          <button
            onClick={toggleMobileMenu}
            style={{
              position: "absolute",
              right: 14,
              top: 14,
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.15)",
              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(10px)",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <X size={16} />
          </button>

          {/* Logo */}
          <img
            src={doxzonLogo}
            alt="Doxzon"
            className="dox-logo"
            style={{
              height: "38px",
              objectFit: "contain",
              width: "auto",
              marginBottom: "12px",
              filter: darkMode ? "none" : "brightness(0) invert(1)",
            }}
          />

          {loggedUser ? (
            <div className="flex items-center gap-3 mt-4">
              <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white font-bold text-lg">
                {loggedUser?.firstName?.charAt(0).toUpperCase()}
              </div>
              <div>
                <div
                  style={{ color: "#fff", fontSize: "16px", fontWeight: 700 }}
                >
                  {loggedUser?.firstName} {loggedUser?.lastName}
                </div>
                <div
                  style={{ color: "rgba(255,255,255,0.7)", fontSize: "12px" }}
                >
                  Patient Account
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                color: "#fff",
                fontSize: "17px",
                fontWeight: 600,
                marginTop: "8px",
              }}
            >
              Healthcare. Simplified.
            </div>
          )}
        </div>

        {/* Menu Items */}
        <div style={{ padding: "16px 12px" }}>
          {loggedUser ? (
            <>
              <div
                style={{
                  padding: "0 8px 8px",
                  fontSize: "11px",
                  fontWeight: 700,
                  color: darkMode ? "#f0c040" : "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                Main Menu
              </div>
              {[
                { label: "Home", route: APP_ROUTES.HOME },
                { label: "Consultation", route: APP_ROUTES.CONSULTDOCTOR },
                { label: "Medicine", route: APP_ROUTES.MEDICINES },
                { label: "Lab Tests", route: APP_ROUTES.LABTESTS },
                { label: "Referral", route: APP_ROUTES.HOSPITALSERVICE },
                { label: "Call Doctor", onClick: handleCallDoctorOpen },
              ].map((item) => (
                <button
                  key={item.label}
                  onClick={() => handleNav(item)}
                  style={{
                    width: "100%",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: 14,
                    background: darkMode ? "rgba(200,150,30,0.05)" : "#fff",
                    marginBottom: 8,
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: darkMode ? "none" : "0 2px 8px rgba(0,0,0,0.04)",
                    border: darkMode
                      ? "1px solid rgba(200,150,30,0.15)"
                      : "1px solid rgba(0,0,0,0.02)",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div className="flex items-center gap-3">
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        background: darkMode
                          ? "rgba(200,150,30,0.1)"
                          : "rgba(24,159,170,0.08)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: darkMode ? "#f0c040" : "#189FAA",
                      }}
                    >
                      {DRAWER_ICONS[item.label]}
                    </div>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: darkMode ? "#f5e6b0" : "#1e293b",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  <ChevronRight
                    size={18}
                    color={darkMode ? "#f0c040" : "#189FAA"}
                    opacity={0.5}
                  />
                </button>
              ))}

              <div
                style={{
                  padding: "16px 8px 8px",
                  fontSize: "11px",
                  fontWeight: 700,
                  color: darkMode ? "#f0c040" : "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                My Healthcare
              </div>
              {[
                { label: "My Profile", route: APP_ROUTES.MYPROFILE },
                { label: "Appointments", route: APP_ROUTES.MYAPPOINMENTS },
                { label: "Diet Plan", route: APP_ROUTES.DIETPLAN },
                { label: "Medical Records", route: APP_ROUTES.MEDICALHISTORY },
                { label: "Health Summary", onClick: handleHSNavigation },
                { label: "Emergency Data", onClick: handleEmgDataView },
              ].map((item) => (
                <button
                  key={item.label}
                  onClick={item.onClick || (() => handleRoute(item.route))}
                  style={{
                    width: "100%",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: 14,
                    background: darkMode ? "rgba(200,150,30,0.05)" : "#fff",
                    marginBottom: 8,
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: darkMode ? "none" : "0 2px 8px rgba(0,0,0,0.04)",
                    border: darkMode
                      ? "1px solid rgba(200,150,30,0.15)"
                      : "1px solid rgba(0,0,0,0.02)",
                  }}
                >
                  <div className="flex items-center gap-3">
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        background: darkMode
                          ? "rgba(200,150,30,0.1)"
                          : "rgba(24,159,170,0.08)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: darkMode ? "#f0c040" : "#189FAA",
                      }}
                    >
                      {DRAWER_ICONS[item.label]}
                    </div>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: darkMode ? "#f5e6b0" : "#1e293b",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  <ChevronRight
                    size={18}
                    color={darkMode ? "#f0c040" : "#189FAA"}
                    opacity={0.5}
                  />
                </button>
              ))}
            </>
          ) : (
            <>
              <div
                style={{
                  padding: "0 8px 12px",
                  fontSize: "12px",
                  fontWeight: 700,
                  color: "#64748b",
                  textTransform: "uppercase",
                }}
              >
                Quick Access
              </div>
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.label}
                  onClick={() => handleNav(item)}
                  style={{
                    width: "100%",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: 14,
                    background: "#fff",
                    marginBottom: 10,
                    padding: "12px 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: "0 4px 20px rgba(0,0,0,.04)",
                  }}
                >
                  <div className="flex items-center gap-4">
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        background: "linear-gradient(135deg,#ecfeff,#d1fae5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#189FAA",
                      }}
                    >
                      {DRAWER_ICONS[item.label]}
                    </div>
                    <span
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#0f172a",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  <ChevronRight size={22} color="#189FAA" />
                </button>
              ))}
            </>
          )}
        </div>

        {/* Footer Actions */}
        <div style={{ padding: "16px", marginTop: "auto" }}>
          {loggedUser ? (
            <button
              onClick={handleLogOut}
              style={{
                width: "100%",
                height: "48px",
                border: "none",
                borderRadius: "14px",
                background: "rgba(239, 68, 68, 0.1)",
                color: "#ef4444",
                fontWeight: 600,
                fontSize: "15px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <LogOut size={18} /> Logout
            </button>
          ) : (
            <div className="flex flex-col gap-3">
              <button
                onClick={() => {
                  handleLoginModal();
                  toggleMobileMenu();
                }}
                style={{
                  width: "100%",
                  height: "48px",
                  border: "none",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg,#189FAA,#0d7a84)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Login
              </button>
              <button
                onClick={() => {
                  handleReg();
                  toggleMobileMenu();
                }}
                style={{
                  width: "100%",
                  height: "48px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "14px",
                  background: "#fff",
                  color: "#64748b",
                  fontWeight: 600,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Sign Up
              </button>
            </div>
          )}
        </div>
      </Drawer>

      {/* doctor/patient registration */}
      <Modal
        open={regModal}
        onCancel={handleRegClose}
        destroyOnClose
        footer={[]}
        width={window.innerWidth <= 768 ? "100%" : "30%"}
        style={{ height: "max-content", padding: "0px" }}
      >
        <SignUp handleRegClose={handleRegClose} />
      </Modal>

      {/* Patient Login */}
      <Modal
        open={loginModal}
        footer={[]}
        className="responsive-modal"
        onCancel={handleLoginModalClose}
        destroyOnClose
      >
        <Login
          handleLoginModal={handleLoginModalClose}
          handleSignup={handleSignUpFromLogin}
        />
      </Modal>

      {/* Emergency data view */}
      <Modal
        open={emgDataModal}
        onCancel={handleEmgClose}
        footer={[]}
        width={450}
        destroyOnClose
      >
        <div>
          <EmergencyDataView />
        </div>
      </Modal>

      <Drawer
        closeIcon={false}
        open={chatOpen}
        destroyOnClose
        onClose={handleChatClose}
      >
        <LiveChat />
      </Drawer>

      <ConsentPopup
        visible={consentModalVisible}
        onClose={() => setConsentModalVisible(false)}
        patientData={loggedUser}
        existingConsentData={fetchedConsentData}
      />

      <CallDoctorModal
        visible={callDoctorModalVisible}
        onCancel={handleCallDoctorClose}
      />
    </nav>
  );
}

export default Navbar;